import PdfGenerator from "./PdfGenerator";

export default PdfGenerator;